
import { computed, defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'WhatsappMigrationWarningStep',

  props: {
    variant: {
      type: String as PropType<'wa_app' | 'other_bsp'>,
      default: 'wa_app',
    },
  },

  emits: ['want-new-number'],

  setup(props) {
    const { t } = useI18n();

    const baseKey = computed(() => (
      props.variant === 'other_bsp'
        ? 'storeParameters.services.whatsappBusinessParameter.onboarding.paths.otherBsp.migration'
        : 'storeParameters.services.whatsappBusinessParameter.onboarding.paths.waApp.warning'
    ));

    return { t, baseKey };
  },
});
